import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import MainNav2Logged from "./MainNav2Logged";

const API_URL = process.env.REACT_APP_API_URL;

const HeaderLogged = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nom, setNom] = useState("");
  const [courriel, setCourriel] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const location = useLocation();
  
  const isGamePage = location.pathname.includes("/jeux/velo");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await axios.post(`${API_URL}/api/infolettre`, {
        nom,
        courriel,
      });

      setSuccess(true);
      setNom("");
      setCourriel("");
    } catch (err) {
      console.error("Erreur inscription infolettre:", err);
      setError(
        err.response?.data?.message ||
          "Erreur lors de l’inscription à l’infolettre"
      );
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setError("");
    setSuccess(false);
  };

  return (
    <div className="nc-HeaderLogged sticky top-0 w-full z-40 relative">
      <MainNav2Logged />

      {/* Bouton jeu */}
{!isGamePage && (
      <div className="absolute left-[240px] top-[0px] z-50">
        <a
          href="https://www.ahuncycle.com/jeux/velo"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/textures/logo.png"
            alt="Jeu vélo"
            className="
              w-24 h-24
              rounded-full
              object-cover
              cursor-pointer
              shadow-xl
              transition duration-300 ease-in-out
              hover:scale-110
              hover:brightness-125
            "
          />
        </a>
      </div>
)}
      {/* Image flottante infolettre */}
      <div className="absolute bottom-0 right-[50px] z-50 transform translate-y-1/2">
        <img
          src="https://ahuncycle.com/images/infolettre.png"
          alt="Infolettre"
          width={300}
          className="cursor-pointer transition duration-300 ease-in-out hover:brightness-125"
          onClick={() => setIsModalOpen(true)}
        />
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-80 relative">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
              onClick={closeModal}
            >
              &times;
            </button>

            <h2 className="text-xl font-bold mb-4">
              S'abonner à l'infolettre
            </h2>

            {success ? (
              <p className="text-green-600 font-semibold text-center">
                Abonnement réussi!
              </p>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                <input
                  type="text"
                  placeholder="Nom"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  className="border border-gray-300 rounded px-3 py-2"
                  required
                />

                <input
                  type="email"
                  placeholder="Courriel"
                  value={courriel}
                  onChange={(e) => setCourriel(e.target.value)}
                  className="border border-gray-300 rounded px-3 py-2"
                  required
                />

                {error && (
                  <p className="text-sm text-red-600">{error}</p>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="bg-yellow-400 hover:bg-yellow-500 text-white font-semibold py-2 rounded transition disabled:opacity-50"
                >
                  {loading ? "Envoi..." : "S'abonner"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderLogged;